import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  orderBy,
  limit,
} from 'firebase/firestore';
import { db } from '../firebase';

const ISLEM_NO_WIDTH = 7;
const OVERFLOW_SCAN = 200;

export function parseBaseIslemNo(raw) {
  const base = String(raw ?? '').split('-')[0].split('/')[0].trim();
  const n = parseInt(base, 10);
  return Number.isNaN(n) ? 0 : n;
}

export function formatIslemNo(n) {
  return String(Math.max(0, Math.floor(n))).padStart(ISLEM_NO_WIDTH, '0');
}

/**
 * Kayıtlı en yüksek işlem numarasını bulur.
 * Eski kayıtlarda doc id = işlem no olabildiği için hem alan hem id kontrol edilir.
 */
async function findMaxExistingIslemNo(sube) {
  let max = 0;
  const col = collection(db, 'subeler', sube, 'islemler');

  const recentSnap = await getDocs(query(col, orderBy('timestamp', 'desc'), limit(500)));
  recentSnap.forEach((d) => {
    const fromField = parseBaseIslemNo(d.data().islemNo);
    const fromId = parseBaseIslemNo(d.id);
    if (fromField > max) max = fromField;
    if (fromId > max) max = fromId;
  });

  const overflowStart = Math.max(1_000_000, max);
  const overflowChecks = await Promise.all(
    Array.from({ length: OVERFLOW_SCAN }, (_, i) =>
      getDoc(doc(db, 'subeler', sube, 'islemler', String(overflowStart + i)))
    )
  );
  for (const snap of overflowChecks) {
    if (!snap.exists()) continue;
    const fromField = parseBaseIslemNo(snap.data().islemNo);
    const fromId = parseBaseIslemNo(snap.id);
    if (fromField > max) max = fromField;
    if (fromId > max) max = fromId;
  }

  return max;
}

/** Sonraki işlem numarasını mevcut kayıtlardan hesaplar (ayrı sayaç dokümanı gerekmez). */
export async function allocateIslemNo(sube) {
  if (!sube) throw new Error('Şube bilgisi eksik');
  const max = await findMaxExistingIslemNo(sube);
  return formatIslemNo(max + 1);
}
